import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const heroImages = [
  'https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmosphere%20with%20abstract%20flowing%20gradients%20in%20amber%20coral%20and%20warm%20cream%20tones%2C%20soft%20bokeh%20lights%2C%20dreamy%20and%20elegant%20background%2C%20minimalist%20composition%2C%20no%20text%2C%20no%20people%2C%20modern%20streaming%20platform%20vibe&width=1600&height=900&seq=hero-bg-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20waves%20and%20curves%2C%20soft%20gradient%20from%20amber%20to%20peach%2C%20luxurious%20textured%20background%2C%20cinematic%20movie%20poster%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20elegant%20and%20sophisticated&width=1600&height=900&seq=hero-bg-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20warm%20geometric%20shapes%20floating%20in%20space%2C%20coral%20and%20gold%20color%20palette%2C%20translucent%20overlapping%20circles%2C%20modern%20minimalist%20design%2C%20cinematic%20depth%20of%20field%2C%20no%20text%2C%20no%20people%2C%20streaming%20service%20aesthetic&width=1600&height=900&seq=hero-bg-03&orientation=landscape',
];

export default function HeroSection() {
  const [currentBg, setCurrentBg] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/dianshiju?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroImages.map((img, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === currentBg ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img src={img} alt="" className="w-full h-full object-cover" />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/60"></div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {[0, 1, 2].map((i) => (
          <button
            key={i}
            onClick={() => setCurrentBg(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === currentBg ? 'bg-primary-500 w-6' : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换背景 ${i + 1}`}
          />
        ))}
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight font-heading">
            高清免费在线观看
            <br />
            <span className="text-primary-400">全集不缓冲</span> 水果视频推荐
          </h1>
          <p className="text-sm md:text-base text-background-300 mb-8 max-w-xl mx-auto leading-relaxed">
            蓝莓视频提供与香蕉视频、蜜桃视频、西瓜视频、樱桃视频同类型的高清影视资源，
            免费在线观看电视剧全集电影大全，不缓冲流畅播放
          </p>

          <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto">
            <div className="relative flex-1 w-full">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-lg"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你想看的电影电视剧..."
                className="w-full pl-11 pr-4 py-3.5 rounded-full bg-background-50/95 text-foreground-900 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 border border-transparent"
              />
            </div>
            <button
              type="submit"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即搜索
            </button>
          </form>

          <div className="flex flex-wrap items-center justify-center gap-2 mt-6">
            <span className="text-xs text-background-400">热门搜索：</span>
            {['繁花', '庆余年2', '流浪地球2', '歌手2024', '斗罗大陆'].map((kw) => (
              <Link
                key={kw}
                to={`/category/dianshiju?q=${kw}`}
                className="px-3 py-1 rounded-full text-xs bg-background-50/15 text-background-200 hover:bg-primary-500/30 hover:text-primary-300 transition-colors border border-background-50/10 whitespace-nowrap cursor-pointer"
              >
                {kw}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => setCurrentBg((currentBg + 1) % 3)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-background-50 text-lg"></i>
      </button>
      <button
        onClick={() => setCurrentBg((currentBg + 1) % 3)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-background-50 text-lg"></i>
      </button>
    </section>
  );
}